module.exports = __webpack_public_path__ + "static/media/rickshaw.62d45b16.PNG";